import React from 'react'
import { Button ,ClickAwayListener} from '@material-ui/core'
import Popover from '@material-ui/core/Popover';
import withStyles from '@material-ui/core/styles/withStyles'
import chevronDown from '../../img/Chev@2x.png'
// import logo from '../../../../img/innovate/Innovation_Logo.jpg'
import banner from '../../img/Hero banner.png'
import HACK_CUP from 'img/KV_HACK_A_CUP.jpg'
import logoWhite from 'img/innovate/Innovation_Logo.jpg'
import images from 'common_constants/images'
import styles from './View.Style'
import { useHistory } from "react-router-dom";
import CustomButton from 'components_newui/customButton/CustomButton';

const Header = (props) => {
  const history = useHistory();
  const {classes, onSignIn,setShowExternalLogin} = props
  const [open, setOpen] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)

  const showLogin = (event) => {
    setOpen((prev) => !prev)
    setAnchorEl(event.currentTarget)
  };

  const hideLogin = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const HandleNavigateLogin =() =>{
    history.push("/login");
  }


  const boolOpen = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined;

  return (
    
      <div className={classes.header}>
        {/* <img className={classes.headerImage} src={images?.banner} alt="Banner" /> */}
        <img className={classes.headerImage} src={HACK_CUP} alt="Banner" />
        {/* <img className={classes.logo} src={images?.logobnw}  alt="logo" /> */}
        {/* <img className={classes.logo} src={logoWhite} alt="logo" /> */}
        <div className={classes.headerOverlay}>
          <span className={classes.welcomeSpan}>
            {/* <p className={classes.welcomeHeader}>Welcome to Innovate</p> */}
            {/* <p className={classes.welcomeText}>Innovation without boundaries</p> */}
            <ClickAwayListener onClickAway={hideLogin}>
              <span>
                {/* <Button
                  variant="contained"
                  color="primary"
                  className={classes.getStarted}
                  onClick={showLogin}
                >
                  Get started
                </Button> */}
                {/* {open ? ( */}

                  {/* <Popover
                    id={id}
                    open={boolOpen}
                    anchorEl={anchorEl}
                    onClose={hideLogin}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  > */}

                    {/* {window.location.origin === 'http://localhost:3000' ||
                    window.location.origin === 'https://dev.eris.vodafone.com' ? ( */}

                      <div className={classes.loginPopup}>
                        <p>Please choose a log in option</p>
                        <div className={classes.loginButtons}>


                          <CustomButton type='button'  
                          variant="contained"
                            color="primary"
                            size="large" className={classes.getStarted}  onClick={() => {
                              hideLogin()
                              onSignIn()
                            }}>
                            Vodafone/Vodacom Credentials
                          </CustomButton>
                          <CustomButton  
                            variant="contained"
                            color="primary"
                            className={classes.getStarted}
                            size="large"
                            // className="vf-custom-shadow"
                            onClick={ HandleNavigateLogin}
                          >   External Login </CustomButton>

                          {/* <Button
                            variant="contained"
                            color="primary"
                            className={classes.getStarted}
                            onClick={() => {
                              hideLogin()
                              onSignIn()
                            }}
                          >
                            Vodafone/Vodacom Credentials
                          </Button>

                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.getStarted}
                            onClick={ HandleNavigateLogin}
                            // onClick={
                            //   // () => {
                            //   // hideLogin()
                            //   // setShowExternalLogin(true)
                             
                            // // }
                            // }
                          >
                            External Login
                          </Button> */}
                        </div>
                      </div>
                    {/* ) : (
                      <div className={classes.loginPopup}>
                        <p>Sign In</p>
                        <div className={classes.loginButtons}>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.getStarted}
                            onClick={() => {
                              hideLogin()
                              onSignIn()
                            }}
                          >
                            SSO Login
                          </Button>
                        
                        </div>
                      </div>
                    )} */}
                  {/* </Popover> */}
                {/* ) : null} */}
              </span>
            </ClickAwayListener>
          </span>
          <img className={classes.down} src={chevronDown} alt="Chevron Down" />
        </div>
      </div>
    
  )
}

export default withStyles(styles)(Header)
